var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useEffect } from 'react';
/** @deprecated never use that anymore */
var RcIconService = /** @class */ (function () {
    function RcIconService() {
        this._iconMapChangeListeners = [];
    }
    RcIconService.getInstance = function () {
        if (!RcIconService.instance) {
            RcIconService.instance = new RcIconService();
        }
        return RcIconService.instance;
    };
    RcIconService.setInstance = function (icons) {
        var _icon = RcIconService.getInstance();
        _icon.setIconMap(icons);
        return _icon;
    };
    RcIconService.prototype.setIconMap = function (iconMap) {
        if (iconMap === this._iconMap)
            return;
        this._iconMap = iconMap;
        this._iconMapChangeListeners.forEach(function (listener) { return listener(iconMap); });
    };
    RcIconService.prototype.getIconMap = function () {
        return this._iconMap;
    };
    RcIconService.prototype.onIconMapChange = function (listener) {
        this._iconMapChangeListeners.push(listener);
    };
    RcIconService.prototype.offIconMapChange = function (listener) {
        this._iconMapChangeListeners = this._iconMapChangeListeners.filter(function (item) { return item !== listener; });
    };
    return RcIconService;
}());
export { RcIconService };
/** @deprecated never use that anymore */
export function useIconService() {
    var iconService = RcIconService.getInstance();
    var _a = __read(useState(iconService.getIconMap()), 2), iconMap = _a[0], setIconMap = _a[1];
    useEffect(function () {
        iconService.onIconMapChange(setIconMap);
        return function () {
            iconService.offIconMapChange(setIconMap);
        };
    }, [iconService]);
    return { iconMap: iconMap };
}
